import {
  CandidateFilterValuesType,
  GroupedOptionsType,
} from '@/components/CandidateFilter/CandidateFilter.types';
import * as Styles from './CandidateFilterAutocomplete.styles';

export type AutocompleteComponentType = {
  selectedOptions?: string[];
  groupedOptions?: GroupedOptionsType[];
  options: CandidateFilterValuesType[];
  input: string;
  withSearch?: boolean;
  onChangeInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectItem: (item: string | number | Date | string[]) => void;
  onRemoveFilterOption: (item: string | number | Date | string[]) => void;
};

const CandidateFilterAutocompleteComponent = ({
  options,
  input,
  onRemoveFilterOption,
  withSearch,
  onSelectItem,
  onChangeInput,
  groupedOptions,
  selectedOptions,
}: AutocompleteComponentType): JSX.Element => {
  const notFound = !options.length && !groupedOptions;
  const withGroupedOptions = !options.length && groupedOptions;
  return (
    <Styles.AutocompleteList>
      {withSearch && (
        <Styles.InputText
          placeholder="Search for an option"
          type="text"
          value={input}
          onChange={onChangeInput}
        />
      )}

      <ul>
        {notFound && (
          <Styles.AutocompleteListItem>
            <Styles.AutocompleteListButton disabled type="button" onClick={() => {}}>
              <p>Not found</p>
            </Styles.AutocompleteListButton>
          </Styles.AutocompleteListItem>
        )}

        {withGroupedOptions &&
          groupedOptions.map((groupedOption) => {
            return groupedOption.options.map((opt, index) => {
              const Element = opt.node;
              const valueAsString = opt.value.toString();
              const isSelected = selectedOptions?.includes(valueAsString);
              return (
                <div key={valueAsString}>
                  {index === 0 && (
                    <Styles.GroupedOptionsSubtitle>
                      {groupedOption.label}
                    </Styles.GroupedOptionsSubtitle>
                  )}
                  <Styles.AutocompleteListItem key={opt.value.toString()}>
                    <Styles.AutocompleteListButton
                      type="button"
                      onClick={() => {
                        if (!isSelected) {
                          onSelectItem(opt.value);
                        }
                      }}
                    >
                      <Element checked={isSelected} />
                    </Styles.AutocompleteListButton>
                  </Styles.AutocompleteListItem>
                </div>
              );
            });
          })}

        {options.map(({ value, node }) => {
          const Element = node;
          const valueAsString = value.toString();
          const isSelected = selectedOptions?.includes(valueAsString);
          const buttonId = valueAsString.toLowerCase().replace(/\s/g, '-');

          return (
            <Styles.AutocompleteListItem key={valueAsString}>
              <Styles.AutocompleteListButton
                type="button"
                data-testid={`candidate-filter-button-item-${buttonId}`}
                onClick={(event) => {
                  event.stopPropagation();
                  if (!isSelected) {
                    onSelectItem(value);
                  } else {
                    onRemoveFilterOption(value);
                  }
                }}
              >
                <Element checked={isSelected} />
              </Styles.AutocompleteListButton>
            </Styles.AutocompleteListItem>
          );
        })}
      </ul>
    </Styles.AutocompleteList>
  );
};

export default CandidateFilterAutocompleteComponent;
